import nBossConnection from 'modules/base/service/nBossConnection';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import ModelValidationLogTableService from '../service/ModelValidationLogTableService';
import ShowChartButton from '../component/ShowChartButton';

const config = {
	key: 'modelValidationLogTable',
	topic: 'modelValidationLog',
	service: ModelValidationLogTableService,
	editFormState: item => `/model-validation-log/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['exportData', 'modify', 'delete'],
	rowButtonList: [{ key: 'showChart', component: ShowChartButton }],
	exportData: {
		tooltip: 'Export to XLSX',
		link: item => `${nBossConnection.basePath}modelValidationLogTableControl/exportToXlsx?id=${item.id}`
	},
	columns: [
		{
			key: 'name'
		},
		{
			key: 'tableName'
		},
		{
			key: 'description'
		}
	]
};

function ModelValidationLogTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('modelValidationLogTable', reducer('modelValidationLogTable'))(ModelValidationLogTable);
